import { EntityType } from 'common/enums/entity-enums.js';
import { surveyRunAssociatedDataMap } from 'common/services/configs/index.js';
import { surveyProgramAssociatedDataMap } from 'common/services/configs/trajectories/associated-data/index.js';
import { KnowEdmTableValue } from 'common/services/configs/interfaces.js';

export const entityAssociatedDataMap = new Map<EntityType, Map<any, KnowEdmTableValue<any>>>();
entityAssociatedDataMap.set(EntityType.SurveyRun, surveyRunAssociatedDataMap);
entityAssociatedDataMap.set(EntityType.SurveyProgram, surveyProgramAssociatedDataMap);
